/**
 * Variables from wordpress wp_localize_script (class: Core.php)
 * kfxNipVars - array
 */

function handleCompanyFields() {
  const checked = document.querySelector('[name="billing_user_is_company"]:checked');
  const form = document.querySelector("form[name='checkout']");
  const invoice = document.querySelector('[name="billing_want_invoice"]');
  const invoiceWrapper = document.querySelector('#billing_want_invoice_field');
  const companyFields = document.querySelectorAll('.company-field');

  if (!checked || !form) {
    return;
  }

  if (checked.value === 'company') {
    form.classList.add('kfx-nip-is-company');
    companyFields.forEach(f => {
      f.style.display = '';
      if (f.querySelector('.optional')) f.querySelector('.optional').style.display = 'none';
    });
    if (invoice) invoice.checked = true;
    if (invoiceWrapper) invoiceWrapper.style.display = 'none';
  } else {
    form.classList.remove('kfx-nip-is-company');
    companyFields.forEach(f => {
      f.style.display = '';
      const input = f.querySelector('input');
      if (input) input.value = null;
      if (f.querySelector('.optional')) f.querySelector('.optional').style.display = '';
    });
    if (invoice) invoice.checked = false;
    if (invoiceWrapper) invoiceWrapper.style.display = '';
  }
}

const toggleInvoiceFields = () => {
  if (document.querySelector('.company-field')) {
    const radios = document.querySelectorAll('[name="billing_user_is_company"]');

    radios.forEach(radio => radio.addEventListener('change', handleCompanyFields));
    handleCompanyFields();
  }
};

window.addEventListener('DOMContentLoaded', () => {
  toggleInvoiceFields();

  const nipField = document.querySelector('#billing_tax_id');
  if (!nipField) return;

  const fields = ['billing_company', 'billing_address_1', 'billing_city', 'billing_postcode'];

  const labels = fields.map(el => document.querySelector(`label[for="${el}"]`)).filter(el => !!el);

  const inputs = fields.map(el => document.querySelector(`#${el}`));

  const fieldsMap = new Map();

  /* eslint-disable no-undef */
  fieldsMap.set('billing_company', kfxNipVars.translations.billing_company);
  fieldsMap.set('billing_address_1', kfxNipVars.translations.billing_address_1);
  fieldsMap.set('billing_city', kfxNipVars.translations.billing_city);
  fieldsMap.set('billing_postcode', kfxNipVars.translations.billing_postcode);
  /* eslint-enable no-undef */

  const toggleFieldLabels = () => {
    labels.forEach(el => el.classList.toggle('active'));
  };

  const calculateNipChecksum = nip => {
    nip = nip.replace(/[ -]/gi, '');
    nip = String(nip);
    if (nip.length !== 10) return false;
    const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    const sum = nip
      .split('')
      .map((current, i) => (weight[i] >= 0 ? parseInt(current) * weight[i] : 0))
      .reduce((a, b) => a + b, 0);
    const controlNumber = nip.slice(-1);
    return String(sum % 11) === controlNumber;
  };

  const createError = message => {
    const el = document.createElement('span');
    el.classList.add('error-message');
    el.innerText = message;
    nipField.parentNode.parentNode.appendChild(el);
  };

  const removeAllErrors = () => {
    const errors = nipField.parentNode.parentNode.querySelectorAll('.error-message');
    for (const error of errors) {
      error.remove();
    }
  };

  const handleNipBlur = async _evt => {
    if (document.querySelector('[name="billing_country"]').value !== 'PL') return;

    removeAllErrors();
    toggleFieldLabels();

    const isNipValid = calculateNipChecksum(nipField.value);

    if (!isNipValid) {
      createError(kfxNipVars.translations.invalidValue); // eslint-disable-line no-undef
      return toggleFieldLabels();
    }

    const adminUrl = kfxNipVars.ajax; // eslint-disable-line no-undef
    const data = new FormData();
    data.append('action', 'get_data');
    data.append('NIP', nipField.value);

    const req = await fetch(adminUrl, {
      method: 'POST',
      body: data,
    });

    const res = await req.json();

    inputs.forEach(el => {
      const key = fieldsMap.get(el.id);
      el.value = res[key];
    });
    toggleFieldLabels();
  };

  nipField.addEventListener('blur', handleNipBlur);
});
